import { RootState } from 'src/store';

export const selectIsAsideShow = (state: RootState): boolean => state.aside;
